/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowDownTail = createReactComponent("outline", "arrow-down-tail", "IconArrowDownTail", [["path", { "d": "M12 6v15", "key": "svg-0" }], ["path", { "d": "M9 18l3 3l3 -3", "key": "svg-1" }], ["path", { "d": "M9 3l3 3l3 -3", "key": "svg-2" }]]);

export { IconArrowDownTail as default };
//# sourceMappingURL=IconArrowDownTail.mjs.map
